// Helpers for user-provided web links (content type 11 "Web link").

const SCHEME_PATTERN = /^[a-z][a-z0-9+.-]*:/i;

/**
 * Returns a safe, absolute http(s) URL for a web link stored on a content record,
 * or null when the value is empty or not a usable web address.
 * Links saved without a scheme (e.g. "example.com/page") get "https://" prefixed.
 */
export const getExternalLinkHref = (webLink) => {
  if (typeof webLink !== "string") return null;
  const trimmed = webLink.trim();
  if (!trimmed) return null;

  const candidate = SCHEME_PATTERN.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;
  try {
    const url = new URL(candidate);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    if (!url.hostname.includes(".") && url.hostname !== "localhost")
      return null;
    return url.href;
  } catch {
    return null;
  }
};

/** Opens a web link in a new tab without giving it access to the opener window. */
export const openExternalLink = (webLink) => {
  const href = getExternalLinkHref(webLink);
  if (!href) return false;
  window.open(href, "_blank", "noopener,noreferrer");
  return true;
};
